import React from 'react';
import { useSelector } from 'react-redux';
import { InlineAlert } from '@saucelabs/ds-alert';
import { constants as userConstants } from '@saucelabs/sl-module-user';
import { Units } from '@saucelabs/sl-module-usage/lib/constants';

import { selectors } from '../index';

const VdcWarnings:React.FC = () => {
  const {
    hasVdcInPlan,
    isUserConcurrencyVdcMaxedOut,
    userConcurrencyAllowedVdc,
    usageUnits,
    orgUserType,
    daysUntilRefresh,
    isFreemiumCapable,
  } = useSelector(selectors.vdcWarningsSelector);

  return (
    <>
      {usageUnits.usageUnit === Units.Credits && usageUnits.totalAvailableUsageUnits <= 0 &&
        isFreemiumCapable && (
        <InlineAlert
          buttonProps={{
            children: 'Find a Plan',
            to: '/billing',
            variant: 'text',
          }}
          className="mb-4"
          color="info"
          title="No credits available."
        >
          {`Your credits will be refreshed in ${daysUntilRefresh} day${daysUntilRefresh > 1 ? 's' : ''}.`}
          {' To keep testing, purchase a plan.'}
        </InlineAlert>
      )}
      {usageUnits.usageUnit === Units.Seconds && usageUnits.totalAvailableUsageUnits <= 0 &&
        orgUserType === userConstants.USER_TYPE_FREEMIUM && (
        <InlineAlert
          buttonProps={{
            children: 'Find a Plan',
            to: '/billing',
            variant: 'text',
          }}
          className="mb-4"
          color="info"
          title="No minutes available."
        >
          {'You have exhausted all minutes. To keep testing, purchase a plan.'}
        </InlineAlert>
      )}
      {orgUserType !== userConstants.USER_TYPE_FREEMIUM && !hasVdcInPlan && (
        <InlineAlert
          buttonProps={{
            children: 'Find a Plan',
            to: '/billing',
            variant: 'text',
          }}
          className="mb-4"
          color="info"
          title="Your plan does not include virtual devices."
        >
          Upgrade to start using them.
        </InlineAlert>
      )}
      {isUserConcurrencyVdcMaxedOut && (
        <InlineAlert
          buttonProps={{
            children: 'Find a Plan',
            to: '/billing',
            variant: 'text',
          }}
          className="mb-4"
          color="warning"
          title={`You’ve reached your testing capacity (${userConcurrencyAllowedVdc} parallel test${userConcurrencyAllowedVdc === 1 ? '' : 's'}).`} // eslint-disable-line @typescript-eslint/restrict-template-expressions
        >
          Try again soon or add more parallel tests to your plan.
        </InlineAlert>
      )}
    </>
  );
};

export default VdcWarnings;
